var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{ref:"grid",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"beforeSetupGrid":_vm.beforeSetupGrid,"summaryOptions":{
        enabled: true,
        columns: ['amount'],
    },"expandedOptions":{
        enabled: true,
        allowExpandingAll: true,
        template: 'payment-details',
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }